var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-card', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "title": "证书查询"
    }
  }, [_c('a-input-search', {
    attrs: {
      "placeholder": "请输入证书编号",
      "enter-button": "查询",
      "size": "large"
    },
    on: {
      "search": _vm.onSearch
    },
    model: {
      value: _vm.awardCode,
      callback: function callback($$v) {
        _vm.awardCode = $$v;
      },
      expression: "awardCode"
    }
  }), _c('a-divider'), _vm.fileUrl ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.fileUrl,
      "alt": ""
    }
  })])]) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };